import React, { useState, useEffect } from 'react';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import Popup from '../../Modal/PopUp';
import { makeStyles } from '@material-ui/core/styles';
import EditAward from '../../AddAwards/EditAward';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { deleteAward } from '../../../store/actions/UserAction';
import AwardPanel from './AwardPanel';
import './AwardAdded.scss';

const useStyles = makeStyles({
  popper: {
    width: 120,
    margin: '0 24px 0 0',
    // boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    // backgroundColor: isMobile ? 'initial' : '#f5f5f5',
    boxShadow: isMobile ? 'none' : 'none',
    backgroundColor: isMobile ? 'transparent' : 'transparent',
  },
  list: {
    width: 120,
    backgroundColor: 'white'
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  }
})

function AwardAdded({ 
  uid,
  allAwards,
  deleteAward,
  elements,
  preview,
  fromPublic,
  handleSnack,
  alreadyRewarded,
  handleRewarded,
  handleTrophieModalOpen,
  handleEditFlag,
  nElem,
  helper,
  helperTrue,
  helperFalse,
  getValues,
  previewExpanded,
}) {
    const [flagEdit, setFlagEdit] = useState(0);

    const FnEditAward = () => {
        setFlagEdit(1)
        setAnchorEl(null)
    };

    const changeStatus = (isActive) => {
        setFlagEdit(0);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [elemIndex, setElemIndex] = useState('')

    const handlePopper = (event, nElem) => {
        if (flagEdit === 1) {
            setFlagEdit(0)
        }
        setElemIndex(nElem)
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const [ outsideOpen, setOutsideOpen ] = useState(false)

    const handleOutside = () => {
        setOutsideOpen(!outsideOpen)
    }

    const confirmDeleteAward = (event) => {
        event.preventDefault()
        setOutsideOpen(false)
        deleteAward(uid, elemIndex, elements).then(res => {
        handleSnack()
        });
        setAnchorEl(null)
        handleSnack()
        setElemIndex('')
    };

    useEffect(() => {
        if (handleEditFlag) {
            handleEditFlag(flagEdit)
        }
    }, [flagEdit, handleEditFlag])

    const openPopper = Boolean(anchorEl);
    const classes = useStyles()
    
  return (
    <>
        {preview || fromPublic ?
            <AwardPanel
                elements={preview ? elements : fromPublic}
                expanded={previewExpanded}
            /> : 
            <>
                {elemIndex !== undefined && outsideOpen ?
                    <Popup
                        open={outsideOpen}
                        handleClose={handleOutside}
                        title={['Seguro que deseas eliminar', <br />, `${elements[elemIndex].name}?`]}
                        subtitle={`Si eliminas ${elements[elemIndex].name} se borrará de tu lista de premios, para regresar presiona el botón Cancelar `}
                        primaryButton={true}
                        primaryButtonVariant='primarySolidOutlined'
                        primaryButtonText='Sí, eliminar'
                        primaryFunction={confirmDeleteAward}
                        secondaryButton={true}
                        secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
                        secondaryButtonVariant='primary'
                    /> : null
                }
                <Popover
                    open={openPopper}
                    anchorEl={anchorEl}
                    className={classes.popper}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                >
                    <List className={classes.list} component="nav" aria-label="secondary mailbox folders">
                        <ListItem
                            className={classes.listItem}
                            button
                        >
                        <ListItemText onClick={FnEditAward} className={classes.listItemText} primary="Editar" />
                        </ListItem>

                        <ListItem
                            className={classes.listItem}
                            button
                        >
                        <ListItemText onClick={handleOutside} className={classes.listItemText} primary="Eliminar" />
                        </ListItem>
                    </List>                
                </Popover>

                <div style={{ width: '100%' }}>
                    {elements && elements.map((elem, index) => {
                        const { name, place, year, myImageAward } = elem;
                        if (index === elemIndex && flagEdit === 1) {
                            return (
                                <EditAward
                                    elements={elements}
                                    outsideOpen={outsideOpen}
                                    handleOutside={handleOutside}
                                    evento={changeStatus}
                                    flagEdit={flagEdit}
                                    setFlagEdit={setFlagEdit}
                                    allAwards={allAwards}
                                    handleSnack={handleSnack}
                                    alreadyRewarded={alreadyRewarded}
                                    handleRewarded={handleRewarded}
                                    handleTrophieModalOpen={handleTrophieModalOpen}
                                    item={elemIndex}
                                    helper={helper}
                                    helperTrue={helperTrue}
                                    helperFalse={helperFalse}
                                    getValues={getValues}
                                />
                            )
                        }
                        return (
                            <div className="awardAdded">
                                <div className="awardAdded_limit">
                                    <div className="awardAdded_container">
                                        {myImageAward &&
                                            <img
                                                src={myImageAward}
                                                alt="award"
                                                className="awardAdded_awardImg"
                                            />
                                        }
                                        <div className="awardAdded_infoContainer">
                                            <p>{name && name}</p>
                                            <p>{place && place}</p>
                                            <p>{year && year}</p>
                                        </div>
                                    </div>
                                    <img
                                        src="/img/expand/menu-options.svg"
                                        alt="award"
                                        className="awardAdded_optionsImg"
                                        onClick={(event) => handlePopper(event, index)}
                                    />
                                </div>
                            </div>
                        )
                        })
                    }
                </div>
            </>
        }
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  deleteAward: (uid, elemIndex, elements) =>
    dispatch(deleteAward(uid, elemIndex, elements)),
})

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  elements: state.authClient.awardsLawyer,
})

export default connect(mapStateToProps, mapDispatchToProps)(AwardAdded);